module.exports = __webpack_public_path__ + "img/Koderly_K.f5f578c7.svg";